import { Component, OnInit } from '@angular/core';
import {RestApiService} from '../shared/restApiServices/restapi.service';
import {isUndefined} from "util";
import { Router , ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent implements OnInit {

  userName: string;
  password:string;
  signUpFail:boolean;
  signUpFailMsg:string;
  email:string;
  color = 'green';
  isShowLoader = false;
  userNameEmpty;
  passwordEmpty;
  signUpCode:string;
  signUpCodeEmpty:string;
  showcode : boolean;
  superAdminID:string = ''

  constructor(private restApiService:RestApiService,private router: Router , private route: ActivatedRoute) {
    this.signUpFail = false;
    this.signUpFailMsg = "";
    this.showcode = true;
    this.route.queryParams.subscribe(params=>
      this.superAdminID = params.superAdminID
      )
      // console.log(this.superAdminID);
  }

  ngOnInit() {
    // this.userName = "+91";
    if(this.route.queryParams['_value']['signUpCode'])
    {
      this.signUpCode = this.route.queryParams['_value']['signUpCode'];
      this.showcode = false;
    }
  }

  signInRequest(){
    this.router.navigateByUrl('/logIn');    
  }

  signUpRequest()
  {
    if(this.userName==null || isUndefined(this.userName) || this.userName=="")
    {
      this.userNameEmpty = "on-error";
      this.passwordEmpty = "";
      return;
    }
    else if(this.password==null || isUndefined(this.password) || this.password=="")
    {
      this.userNameEmpty = "";
      this.passwordEmpty = "on-error";
      return;
    }
    // else if(this.signUpCode==null || isUndefined(this.signUpCode) || this.signUpCode=="")
    // {
    //   this.userNameEmpty = "";
    //   this.passwordEmpty = "";
    //   this.signUpCodeEmpty = "on-error";
    //   return;
    // }
    else {
      this.userNameEmpty = "";
      this.passwordEmpty = "";
      this.signUpCodeEmpty = "";
      this.signUpFailMsg = "";
      this.isShowLoader=true;

      this.restApiService.signUpService(this.userName, this.password,this.email,this.signUpCode,this.superAdminID,'A','').subscribe(
        result => {

          if(result.success)
          {
            this.isShowLoader = false;
            this.router.navigate(['/confirmSignUp'],{ queryParams: { userName: this.userName,uID:result.data.UserSub }} );
          }
          else {
            //signUp failed
            this.isShowLoader = false;
            this.signUpFailMsg = result.value;
            this.signUpFail = true;
            // console.log(this.signUpFailMsg);
          }

        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sign-up/sign-up.component.ts